export default __webpack_public_path__ + "static/media/hamdard-force.f9bc9579.png";